export default {
    namespaced: true,
    state: {
        title: 'NowYu.WE',
        sidebar: true,
        currentColor: 'amber',
        breadcrumbItems: [],
    },
    getters: {
    },
    /* eslint-disable no-param-reassign */
    mutations: {
        TITLE(state, data) {
            state.title = data;
        },
        SIDEBAR(state, data) {
            state.sidebar = data;
        },
        BREADCRUMBS(state, data) {
            state.breadcrumbItems = data;
        },
    },
    actions: {
    },
};



// WEBPACK FOOTER //
// ./src/store/nav.js